<wlm-spinner-wrapper class="wtr-fx-flex-grow">
  <div class="buttons">
    <button
      mat-icon-button
      [matTooltip]="T_SCOPE + '.show-chart' | translate | lowercase"
      class="button-position"
      (click)="openAttributesPopup()"
      [disabled]="!selectedAttributes?.length"
    >
      <mat-icon class="material-icons-outlined">show_chart</mat-icon>
    </button>
  </div>

  <wlm-local-grid
    class="wtr-fx-flex-grow"
    *ngIf="gridSettings"
    [gridSettings]="gridSettings"
    [gridData]="gridAttributeValues"
    [(selectedItems)]="selectedAttributes"
  ></wlm-local-grid>
</wlm-spinner-wrapper>
